import * as Constants from '../../constants';

import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Card, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function LoginForm(props) {
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    async function fetchDollarCurrent() {
        try {
            const response = await fetch(
                'https://investidorlibertario.terradata.com.br/api/quotations/dollar.php'
            );

            if (!response.ok) {
                throw new Error('Erro ao obter cotação do dólar');
            }
            const data = await response.json();
            const value = data.value;
            console.warn(value)
            // ajuste o campo conforme o retorno real da API
            const dollarCurrent = Number(value) ?? 0;

            localStorage.setItem('dollarCurrent', dollarCurrent);

            return dollarCurrent;
        } catch (error) {
            console.error(error);
            return null;
        }
    }

    async function handleSubmit(event) {
        event.preventDefault();

        setShowError(false);
        setIsSubmitting(true);

        try {
            const response = await fetch(Constants.LOGIN, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ email, password })
            });

            if (response.status === 401 || response.status === 422) {
                setErrorMessage("Email ou senha inválidos.");
                setShowError(true);
                setIsSubmitting(false);
                return;
            }

            if (!response.ok) {
                setErrorMessage("Erro no servidor.");
                setShowError(true);
                setIsSubmitting(false);
                return;
            }

            const data = await response.json();
            console.log(data);

            if (data?.token) {
                await fetchDollarCurrent();
                props.onLogin(data);
                navigate('/carteira');
            } else {
                setErrorMessage("Não foi possível autenticar.");
                setShowError(true);
            }

        } catch (error) {
            setErrorMessage("Falha na conexão com o servidor.");
            setShowError(true);
        }

        setIsSubmitting(false);
    }

    return (
        <Container
            fluid
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "100vh" }}
        >
            <Row className="w-100 justify-content-center">
                <Col xs={11} sm={8} md={6} lg={4}>
                    <Card className="p-4 shadow-lg border-0 rounded-4">
                        <Card.Body>

                            <h4 className="text-center mb-4">Entrar na sua conta</h4>

                            {showError && (
                                <Alert variant="danger">
                                    {errorMessage}
                                </Alert>
                            )}

                            <Form onSubmit={handleSubmit}>

                                <Form.Group className="mb-3">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="Digite seu email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        required
                                    />
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label>Senha</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Digite sua senha"
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                        required
                                    />
                                </Form.Group>

                                <div className="d-grid">
                                    <Button
                                        variant="primary"
                                        type="submit"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    className="me-2"
                                                />
                                                Entrando...
                                            </>
                                        ) : (
                                            "Entrar"
                                        )}
                                    </Button>
                                </div>

                            </Form>

                        </Card.Body>
                    </Card>
                    <br /><br /><br /><br />
                </Col>
            </Row>
        </Container>
    );
}

export default LoginForm;